import { TabClusterComuniModel } from "./tabClusterComuni.model";

export class InsertClusterComuniINModel {
    tabClusterComuni: TabClusterComuniModel
}